import { ComponentProps } from 'react';
import { CloseButton, Dialog as DialogWrapper, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import styles from './Dialog.module.css';

interface Props extends ComponentProps<'dialog'> {
  open: boolean;
  onClose: () => void;
  hideCloseButton?: boolean;
  diableBackgroundClose?: boolean;
}

export default function Dialog({
  open,
  onClose,
  className,
  children,
  hideCloseButton = false,
  diableBackgroundClose = false,
}: Props) {
  return (
    <DialogWrapper
      open={open}
      onClose={diableBackgroundClose ? () => null : onClose}
      transition
      className={styles.dialog}
    >
      <DialogBackdrop
        transition
        className={clsx(styles.dialogBackdrop, diableBackgroundClose && styles.disabledBackdrop)}
      />

      <DialogTitle className={styles.visuallyHidden}>Deactivate account</DialogTitle>

      <DialogPanel
        transition
        className={clsx(styles.dialogPanel, className)}
      >
        {children}
        {!hideCloseButton && (
          <CloseButton
            className={styles.closeButton}
            onClick={diableBackgroundClose ? onClose : undefined}
          >
            <XMarkIcon />
          </CloseButton>
        )}
      </DialogPanel>
    </DialogWrapper>
  );
}
